import { Component, EventEmitter, Input, OnInit, Output, HostBinding, ElementRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-widget-textbox',
  templateUrl: './widget-textbox.component.html',
  styleUrls: ['./widget-textbox.component.scss'],
  standalone: false
})
export class WidgetTextboxComponent implements OnInit {
  @ViewChild('inputEl') inputEl: ElementRef<HTMLDivElement>;
  @Input() model: string;
  @Input() placeholder: string = "";
  @Output() modelChange = new EventEmitter<string>();
  @Input() title: string = "";
  @Input() textboxWidth: string = '200px';
  @Input() disabled: boolean = false;
  @Input() notifier: Subject<any>;
  @Input() isExistCat: boolean = false;
  @Input() numericOnly: boolean = false;
  @Input() tooltip?: string;
  @Input() errorMessage?: string = "";
  @Output() onEdit = new EventEmitter<any>();
  @Output() validityChange = new EventEmitter<boolean>();
  isFocus: boolean;
  minValue = 5;
  maxValue = 3650;
  isValid: boolean = true;
  errMssg: string = "";

  constructor() { }
  ngOnInit(): void {
    this.notifier?.subscribe(value => {
      setTimeout(() => {
        this.inputEl.nativeElement.focus();
      }, 0)
    });
  }

  onInput(event: any) {
    let value = event.target.value;

    if (this.numericOnly) {
      // Keep only digits (0–9)
      value = value.replace(/[^0-9]/g, '');
      event.target.value = value;
    }

    this.model = value;
    this.modelChange.emit(value);

    if (this.errorMessage.length > 0) {
      this.validate();
    }
  }

  onEnter() {
    this.isFocus = false;
    this.onEdit.emit();
  }

  onBlur() {
    this.isFocus = false;
    this.onEdit.emit();
  }

  validate() {
    if (!this.model || this.model.trim() === '') {
      this.isValid = false;
      this.errMssg = '';
      this.validityChange.emit(true);
      return;
    }

    const num = Number(this.model);

    if (isNaN(num) || num < this.minValue || num > this.maxValue) {
      this.isValid = false;
      this.errMssg = this.errorMessage;
    } else {
      this.isValid = true;
      this.errMssg = '';
    }

    this.validityChange.emit(this.isValid);
  }
}
